<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar" />
      <DashboardLoading />

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss" scoped>


</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import DashboardLoading from '@/components/Dashboard/Layout/DashboardLoading.vue';

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      DashboardLoading
      // UserMenu,
    },
    data () {
      return {
        showDashboardLoader: true
      }
    },
    fetchData () {
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
